import { api } from './client'

export const getSecupayTransactionStatus = (transactionId: string) => {
    return api.get(`secupay/payment-transaction?smart_transaction_id=${transactionId}`)
}

export const generateNewPaymentLink = (orderId: string) => {
    return api.post(`secupay/payment-transaction/${orderId}/retry`)
}
